export class ReplenishmentModel {
  department:any;
  position1:any;
  position2:any;
  position3:any;
  position4:any;
  position5:any;
  position6:any

  constructor(department,position1,  position2, position3 ,position4,  position5,  position6) {
    this.department=department;
    this.position1=position1;
    this.position2=position2;
    this.position3=position3;
    this.position4=position4;
    this.position5=position5;
    this.position6=position6;
  }
}



// WEBPACK FOOTER //
// ./src/models/ReplenishmentModel.ts